export function parserString (string) {
    if(!string) return "";
    return "district-"+string.toLowerCase().replace(" ","-");
}